module.exports = __webpack_public_path__ + "img/MX-C150093A-BD-HQ.f71b2ab0.png";